import React from "react";
import Input from "components/input/input";
import CustomCheckbox from "components/checkbox/custom-checkbox";
import Select from "components/select/select";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import PopInfo from "components/info-popup/pop-info";
import { useWindowDimensions } from "utils/customhooks";

const func = () => { };

export default function DateInput({
  date = {},
  setDate = func,
  label = "",
  labelClass = "text-sm font-bold text-darkerGray",
  showApp = false,
  showPresent = false,
  name = "",
  errors = {},
  fieldKey,
  required = false,
  isClearable = false,
  showPopInfo = false,
  popInfoType = "",
  showMediaHandle = ()=>{},
}) {
  const {t} = useTranslation();
  const {isMobile} = useWindowDimensions();
  const months = [
    {
      label: t('january'),
      value: 1
    },
    {
      label: t("february"),
      value: 2
    },
    {
      label: t("march"),
      value: 3
    },
    {
      label: t("april"),
      value: 4
    },
    {
      label: t("may"),
      value: 5
    },
    {
      label: t("june"),
      value: 6
    },
    {
      label: t("july"),
      value: 7
    },
    {
      label: t("august"),
      value: 8
    },
    {
      label: t("september"),
      value: 9
    },
    {
      label: t("october"),
      value: 10
    },
    {
      label: t("november"),
      value: 11
    },
    {
      label: t("december"),
      value: 12
    },
  ]

  // const year = new Date().getFullYear() + 5000;
  const year = 2099;
  // const [approximately, setApproximately] = useState(false);
  // const [toPresent, setToPresent] = useState(false);

  // const yearOption = useMemo(() => {
  //   let years = [];
  //   const currentYear = new Date().getFullYear() + 1;
  //   let startYear = 1900;
  //   while (startYear <= currentYear) {
  //     years.push({
  //       label: startYear,
  //       value: startYear,
  //     });
  //     startYear++;
  //   }
  //   return _.reverse(years);
  // }, []);

  const handleChange = (e) => {
    const re = /^[0-9\b]+$/;
    const { name, value } = e.target;

    if(name === "year" && value.length > 4) {
      return e.preventDefault();
    }

    if(e.target.name === "month") {
      if(date.month === e.target.value) {
        setDate((prev) => ({ ...prev, month: null, present: false }));
        return;
      }

      if(e.target.value === null) {
        setDate((prev) => ({ ...prev, month: null, present: false }));
        return;
      }
    }

    if (value === "" || re.test(value)) {
      if(e.target?.max && parseInt(e.target?.max) < parseInt(value)){
        setDate((prev) => ({ ...prev, [name]: e.target.max, present: false }));
        return;
      }
      setDate((prev) => ({ ...prev, [name]: value, present: false }));
    }
  };

  const setMinYear = (e) =>{ 
    const { name, value } = e.target;
    if(e.target?.min && parseInt(e.target?.min) > parseInt(value)){
      setDate((prev) => ({ ...prev, [name]: e.target.min, present: false })); 
      return;
    }
  }

  return (
    <div className="w-full mb-6">
      {label && <label className={`${labelClass} leading-4 ${required ? "marked" : ""} flex flex-row gap-x-2 items-center`}>
        <div>
          {label}
        </div>
        {showPopInfo && 
          <div className="text-black font-normal">
            <PopInfo type={popInfoType} showMediaHandle={showMediaHandle} 
              borderColor="border-darkerGray" direction={isMobile ? 'left' : 'left'} 
              responsive = {isMobile ? {left:"15px", arrow_left:"15px"} : null} 
              topCss="-8.5rem"/>
          </div>} 
      </label>}
      <div className={`w-full grid 3sm:grid-cols-12 gap-3 ${label && "mt-2"}`}>
        <div className="3sm:col-span-3">
          <Input
            min="1"
            max="31"
            value={date?.day || ""}
            name="day"
            placeholder={t('day')}
            inputClass="border border-borderGray rounded-md"
            outsideLabelClass="text-sm font-bold text-darkerGray"
            noLabelPaddingY="1rem"
            type="number"
            onChange={handleChange}
            errorMessage={errors[`${fieldKey}.day`]}
            errorMessagePosition="bottom"
            disableUpDownArrow={true}
          />
        </div>
        {/* <Input
          min="1"
          max="12"
          value={date?.month || ""}
          name="month"
          placeholder="Month"
          inputClass="border border-borderGray rounded-md"
          outsideLabelClass="text-sm font-bold text-darkerGray"
          noLabelPaddingY="1rem"
          type="number"
          onChange={handleChange}
          errorMessage={errors[`${fieldKey}.month`]}
          errorMessagePosition="bottom"
          disableUpDownArrow={true}
        /> */}
        <div className="3sm:col-span-5">
          <Select
            options={months}
            placeholder={t('month')}
            name="month"
            value={date?.month ? months.filter((m) => m.value === date.month)[0] : ""}
            height={58}
            onChange={(e) => {
              console.log(e);
              handleChange({
                target: { name: "month", value: e?.value ?? null },
              });
            }} 
            formContainer="date-container"
            errorMessage={errors[`${fieldKey}.month`]}
            labelClass="text-sm font-bold text-darkerGray leading-4 marked"
            onlyText={true}
            isClearable={isClearable}
          />

        </div>
        <div className="3sm:col-span-3">
          <Input
            min="1900"
            max={`${year}`}
            value={date?.year || ""}
            name='year'
            placeholder={required ? `* ${t('year')}` : t('year')}
            inputClass="border border-borderGray rounded-md"
            outsideLabelClass="text-sm font-bold text-darkerGray"
            noLabelPaddingY="1rem"
            type="number"
            onChange={handleChange}
            errorMessage={errors[`${fieldKey}.year`]}
            errorMessagePosition="bottom"
            disableUpDownArrow={true}
            onWheel={(e)=>e.target.blur()}
            onBlur={setMinYear}
            maxLength={4}
          />
          {/* {
            (_.isEmpty(errors[`${fieldKey}.year`]) && name === 'startDate' && !date?.year) &&
            <label className="input-error-message">* {t('startYearRequired')}</label>
          } */}
        </div>
      </div>

      <div className="w-full milestone-checkbox-form mt-4  grid 3sm:grid-cols-12">
        <div className="flex gap-4 items-center sm:gap-10 3sm:col-span-8">
          {showApp && (
            <CustomCheckbox
              label={
                <p className="text-sm text-darkerGray leading-6 whitespace-nowrap">
                  {t('approximately')}
                </p>
              }
              name={`approximately-${name}`}
              checked={date.approximately}
              // onChange={(e) => setApproximately(e.target.checked)}
              onChange={(e) =>
                setDate((prev) => ({
                  ...prev,
                  approximately: e.target.checked,
                }))
              }
            />
          )}
          {date.hasOwnProperty("present") && showPresent && (
            <CustomCheckbox
              label={
                <p className="text-sm text-darkerGray leading-6 whitespace-nowrap">
                  {t('toPresent')}
                </p>
              }
              name={`toPresent-${name}`}
              checked={date.present}
              // onChange={(e) => setToPresent(e.target.checked)}
              onChange={(e) =>
                setDate((prev) => ({ ...prev, present: e.target.checked }))
              }
            />
          )} 
        </div>
        <div className="3sm:col-span-4">
          {
            (_.isEmpty(errors[`${fieldKey}.year`]) && name === 'startDate' && !date?.year) &&
            <label className="input-error-message">* {t('startYearRequired')}</label>
          }
        </div>
      </div>
    </div>
  );
}
